module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayBold.56eb948.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayBold.ttf
// module id = pQVo
// module chunks = 1